import { render, staticRenderFns } from "./RegistrationIssues.vue?vue&type=template&id=ec8a9708&scoped=true"
import script from "./RegistrationIssues.vue?vue&type=script&lang=js"
export * from "./RegistrationIssues.vue?vue&type=script&lang=js"
import style0 from "./RegistrationIssues.vue?vue&type=style&index=0&id=ec8a9708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8a9708",
  null
  
)

export default component.exports